import CatalogList from "../catalog/CatalogList";

/** Tela de serviços; mantém rota própria sem duplicar a listagem do catálogo. */
const ServiceList = () => <CatalogList type="SERVICE" />;

export default ServiceList;
